module.exports = __webpack_public_path__ + "media/images/common/content_bg-e1738f7d9e1d42247935a1d656f9214b.png";